import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useMemo } from 'react';
import { Element } from 'react-scroll';
import { Field } from 'redux-form';
import { propArrayShape, propShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import SolutionError from '../Error';
const SolutionTagCheckBox = (props) => {
    const { formFields, name, solutionTags } = props;
    const error = useMemo(() => {
        const isTouch = _.get(formFields, `fields.${name}_list.touched`);
        if (isTouch) {
            return _.get(formFields, `syncErrors.${name}_list`);
        }
        return '';
    }, [formFields, name]);
    return (_jsxs(Element, Object.assign({ name: `${name}_view` }, { children: [_jsx("ul", Object.assign({ className: 'inline-multiple-checkbox bg_gray' }, { children: solutionTags.map((tag) => (_jsx("li", Object.assign({ className: 'mr05 mb1' }, { children: _jsxs("div", Object.assign({ className: '' }, { children: [_jsx(Field, { className: 'mdc-checkbox__native-control', component: 'input', id: `${name}_${tag.id}`, name: `${name}[${tag.id}]`, type: 'checkbox', value: tag.id }), ' ', _jsx("label", Object.assign({ htmlFor: `${name}_${tag.id}` }, { children: tag.name }))] })) }), tag.id))) })), _jsx(SolutionError, { error: error })] })));
};
SolutionTagCheckBox.propTypes = {
    formFields: propShape().isRequired,
    name: propStr().isRequired,
    solutionTags: propArrayShape().isRequired,
};
export default SolutionTagCheckBox;
